// Translated
// Migrated
<template>
  <div
    v-if="data"
    ref="tripadvisor"
    class="hotel-info-tripadvisor flex flex-wrap -mx-4"
    :class="pretty ? ['tripadvisor-container bg-light-beige'] : []"
  >
    <div class="md:w-4/12 px-4">
      <h4
        class="tripadvisor-title mb-2"
        data-i18n="tripadvisorTitle"
      >
        {{ $t('tripadvisorTitle') }}
      </h4>
      <div class="flex items-center mb-2">
        <img
          class="-ml-2"
          :src="washUrl(data?.rating_image_url)"
          :alt="$t('tripadvisorTitle')"
        />
        <a
          class="ml-2 c-text-gray link-underline"
          :href="washUrl(data?.web_url)"
          target="_blank"
          data-i18n="tripadvisorNumberOfReviews"
        >{{ $t('tripadvisorNumberOfReviews', { reviews: data?.num_reviews }) }}</a>
      </div>
      <div class="tripadvisor-ranking">
        <strong
          v-if="data?.ranking_data"
          v-html="data?.ranking_data?.ranking_string"
        />
      </div>
      <div
        v-for="(award, award_index) in data?.awards"
        :key="`aW_${award_index}`"
        class="tripadvisor-award mt-4"
      >
        <img :src="washUrl(award?.images?.small)" />
        <span class="ml-2">
          {{ award?.display_name }}
        </span>
      </div>
    </div>
    <div class="md:w-4/12 px-4 mt-6 md:mt-0">
      <div
        v-for="subrating in data?.subratings"
        :key="subrating?.name"
        class="tripadvisor-rating-item"
      >
        <small class="rating-span">
          {{ subrating?.localized_name }}
        </small>
        <img
          :src="washUrl(subrating?.rating_image_url)"
          :alt="subrating?.value"
        />
      </div>
    </div>
    <div
      v-if="data?.review_rating_count"
      class="md:w-4/12 px-4"
    >
      <div
        v-for="n in [1, 2, 3, 4, 5].reverse()"
        :key="n"
        class="tripadvisor-rating-item"
      >
        <small
          class="rating-span"
          :data-i18n="`tripadvisorRating${n}`"
        >{{ $t(`tripadvisorRating${n}`) }}</small>
        <div class="tripadvisor-rating-item__bar">
          <div
            class="tripadvisor-rating-item__bar__score"
            :style="{ width: percentage(data?.review_rating_count[n], data?.num_reviews) + '%' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    pretty: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    percentage (curr, total) {
      return (100 * parseFloat(curr)) / parseFloat(total)
    },

    washUrl (url) {
      return (url || '').replace('http:', 'https:')
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/product/_tripadvisor";

.tripadvisor-container {
  border: none;
  padding: 60px 40px 60px 40px;

  @media (max-width: theme('screens.md')) {
    padding: 30px 18px 30px 18px;
  }

  .tripadvisor-title {
    font-size: 1.35rem;
  }
}
</style>
